import type { Universe, PricingToggle } from '@/types/universe';

export const universes: Universe[] = [
{
  id: 'parc',
  label: 'Parc à thème',
  emoji: '🎢',
  heroTitle: 'Chaque instant,',
  heroTitleItalic: 'filmé',
  heroTitleEnd: 'devient un souvenir partagé.',
  heroSubtitle: 'Guide pas à pas pour révéler vos émotions en vidéo',
  heroDesc: 'Créez la vidéo souvenir qui vous ressemble et partagez-la sur vos réseaux grâce à DreamerLife.',
  heroBg: "/assets/images/background.jpeg",
  stats: [
  { value: '80 000+', label: 'familles guidées' },
  { value: '98%', label: "d'utilisateurs satisfaits" },
  { value: '5', label: 'GUIDES TOURNAGES' },
  { value: '4.9★', label: 'note moyenne' }],

  featuresTitle: 'un véritable film',
  featuresTitleAccent: 'de professionnel',
  featuresDesc: 'Le guide DreamerLife couvre chaque moment clé de votre journée, selon vos désirs.',
  features: [
  { tag: 'Ouverture', title: "Plans d'ouverture magiques", desc: "Capturez l'arrivée au parc avec les angles qui donnent la chair de poule — château en contre-plongée, famille de dos, lumière dorée." },
  { tag: 'Émotions', title: 'Réactions authentiques', desc: 'Le guide vous dit exactement quand et comment filmer les vrais moments — la surprise, le fou rire, les yeux qui brillent.' },
  { tag: 'Attractions', title: "Séquences d'attractions", desc: 'Immortalisez les sourires pour toujours !' }],

  stepsTitle: 'Simple à suivre,',
  stepsTitleAccent: 'impossible à rater.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide', desc: 'Sélectionnez selon vos envies et pack.', badge: 'Guide disponible immédiatement après paiement.' },
  { num: '02', title: 'Consultez votre guide depuis la WebApp', desc: 'Un tutoriel personnalisé depuis votre smartphone. Chaque scène est expliquée : cadrage, durée, moment idéal.', badge: 'Format interactif WebApp' },
  { num: '03', title: 'Filmez, vivez, revivez', desc: "Des instructions claires à suivre selon votre rythme, un vrai jeu d'enfant !", badge: 'Compatible smartphone.' }],

  stepImage: "https://images.unsplash.com/photo-1593055473974-89ad249b19f7",
  stepImageAlt: 'Parent filmant son enfant avec un smartphone dans un parc d\'attractions',
  testimonialTitle: 'DES FAMILLES, DES AMIS,',
  testimonialTitleAccent: 'DES SOUVENIRS, DES FILMS',
  testimonials: [
  { name: 'Damien', role: 'Eklo Hôtel Marne-la-Vallée · Directeur', quote: "L'essayer, c'est l'adopter !", text: "EKLO Hôtel a fait le choix d'intégrer DREAMERLIFE à son offre de services. Les clients adorent repartir avec des souvenirs vidéo de qualité qu'ils peuvent partager sur leurs réseaux. Une émotion partagée pour une expérience client unique.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1dc3ca365-1772624160407.png", avatarAlt: 'Damien, Directeur Eklo Hôtel' },
  { name: 'Thierry M.', role: 'Visiteur · Disneyland Paris', quote: 'La meilleure décision de notre séjour !', text: "Grâce au guide, j'ai filmé des scènes que je n'aurais jamais pensé à capturer. Ma famille regarde encore la vidéo des mois après. Un souvenir inestimable.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_144515c36-1773119084863.png", avatarAlt: 'Thierry M., visiteur' },
  { name: 'Nadia O.', role: 'Maman · 3 enfants', quote: 'Tellement simple et tellement beau !', text: "Je ne suis pas du tout vidéaste mais le guide m'a rendu capable de filmer comme une pro. Le résultat final m'a fait pleurer de joie. Je recommande à 100%.", avatar: "https://images.unsplash.com/photo-1616479067213-3b15d3e01619", avatarAlt: 'Nadia O., maman' }],

 testimonialPhotos: [
  { src: "/assets/images/1.png", alt: "Portrait d'une amie souriante" },
  { src: "/assets/images/2.png", alt: "Portrait d'un enfant heureux" },
  { src: "/assets/images/3.png", alt: "Portrait d'une famille enlacée" },
  { src: "/assets/images/4.png", alt: "Portrait d'une famille heureuse" }],

  videoTitle: 'Votre choix,',
  videoTitleAccent: 'vos souvenirs.',
  videoDesc: 'La réalisation à la hauteur de vos émotions !',
  videoModes: [
  { tag: 'Vous tenez la caméra', title: 'Standard', desc: 'Filmez vos proches et l\'ambiance. Le téléphone est tourné vers les autres, le décor, les attractions.', badge: 'Inclus dans tous les forfaits', image: "https://images.unsplash.com/photo-1688998057518-15dcc45f7a2b", imageAlt: 'Mode standard - filmer les autres', video: '/assets/videos/non-selfie.mp4', poster: '/assets/images/non-selfie-poster.jpg' },
  { tag: 'Vous êtes dans le cadre', title: 'Selfie', desc: 'Tournez la caméra vers vous. Capturez vos émotions et sourires face à l\'objectif.', badge: 'Inclus dans Emotion & Prestige', image: "https://images.unsplash.com/photo-1609039425407-15c3aadfa733", imageAlt: 'Mode selfie - se filmer soi-même', video: '/assets/videos/selfie.mp4', poster: '/assets/images/selfie-poster.jpg' }],

  videoStyles: [
  { title: 'Cinema', desc: 'Plans larges, ralentis cinématographiques et musique épique. Pour une émotion grand écran.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_168a1f9d7-1780419272195.png", imageAlt: 'Style cinéma', videoStandard: '/assets/videos/DL2026_Cinema_no_logo.mp4', videoSelfie: '/assets/videos/DL2026_Cinema_selfie_no_logo.mp4' },
  { title: 'Classic', desc: 'Un montage sobre et raffiné. La beauté du souvenir sans artifice, juste vos moments.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_16652efb4-1780419272340.png", imageAlt: 'Style classique', videoStandard: '/assets/videos/DL2026_Classic_no_logo.mp4', videoSelfie: '/assets/videos/DL2026_Classic_selfie_no_logo.mp4' },
  { title: 'Emotion', desc: 'Musique douce, focus sur les regards et les sourires. Pour un souvenir qui vous touche.', image: "https://images.unsplash.com/photo-1735685034870-0fde92b6a633", imageAlt: 'Style émotion', videoStandard: '/assets/videos/DL2026_Emotion_no_logo.mp4', videoSelfie: '/assets/videos/DL2026_Emotion_selfie_no_logo.mp4' },
  { title: 'Fun', desc: 'Coupes dynamiques, musique entraînante, transitions punchy. Pour vibrer à chaque seconde.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_189328f33-1767716484046.png", imageAlt: 'Style fun', videoStandard: '/assets/videos/DL2026_Fun_no_logo.mp4', videoSelfie: '/assets/videos/DL2026_Fun_selfie_no_logo.mp4' }],

  pricingTitle: 'Facile, Rapide,',
  pricingTitleAccent: 'Accessible.',
  pricingDesc: 'Choisissez le pack adapté à votre souvenir.',
  plans: [
  {
    tag: 'Pour tester le concept',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Un guide complet pour une vidéo exceptionnelle, idéal pour une première expérience DreamerLife.',
    features: [
    { included: true, text: '1 guide interactif disponible (standard)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Accès à la galerie' },
    { included: true, text: 'Support email illimité' },
    { included: true, text: 'Réception vidéo montée sous 4 heures' },
    { included: false, text: 'Parcs illimités' },
    { included: false, text: 'Guide personnalisé famille' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Immersion',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'Accès au guide complet pour une personnalisation idéale.',
    features: [
    { included: true, text: '2 guides interactifs (Standard et Selfie)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Accès à la galerie' },
    { included: true, text: 'Support email illimité' },
    { included: true, text: 'Réception vidéo montée sous 2 heures' },
    { included: true, text: 'Insertion des prénoms et du Parc avec date' }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'Accès au guide complet pour une vidéo ultime de vos souvenirs.',
    features: [
    { included: true, text: '3 guides interactifs (Standard, Selfie et Introduction)' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Accès à la galerie' },
    { included: true, text: 'Support email illimité' },
    { included: true, text: 'Réception vidéo montée sous 15 minutes' },
    { included: true, text: 'Sans insertion copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir avant de commencer votre aventure DreamerLife.',
  faqs: [
  { q: "Qu'est-ce que DreamerLife ?", a: "DreamerLife est un guide de tournage vidéo interactif conçu pour les familles qui visitent des parcs d'attractions. Nous fournissons un guide pas à pas pour filmer des souvenirs cinématographiques — sans être vidéaste professionnel." },
  { q: "À qui s'adresse DreamerLife ?", a: "DreamerLife est fait pour les couples et les parents qui souhaitent capturer de magnifiques souvenirs lors de leurs visites. Aucune compétence technique n'est requise — nos guides sont conçus pour être utilisés avec un simple smartphone." },
  { q: 'Comment accéder au guide ?', a: 'Il vous suffit de choisir votre plan tarifaire, de sélectionner votre guide de tournage, et de finaliser votre commande en ligne. Votre guide est disponible immédiatement depuis notre WebApp (sans téléchargement).' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit amplement. Nos guides sont optimisés pour la vidéo mobile.' },
  { q: "Y'a-t-il une limite d'usage d'un Pack ?", a: "Non, vous pouvez utiliser votre guide sans limite. Le montant payé comprend le guide et la génération de votre vidéo finale. Tant que vous n'avez pas soumis vos rushs, vous pouvez ajuster vos meilleures scènes." }]

},
{
  id: 'auto',
  label: 'Auto/Moto',
  emoji: '🏎️',
  heroTitle: 'Chaque bolide,',
  heroTitleItalic: 'filmé',
  heroTitleEnd: 'devient une légende.',
  heroSubtitle: 'Guide cinématographique pour passionnés de mécanique',
  heroDesc: 'Capturez la puissance, le style et les émotions de vos véhicules avec un guide vidéo professionnel.',
  heroBg: "https://img.rocket.new/generatedImages/rocket_gen_img_1191b649f-1773684206570.png",
  stats: [
  { value: '15 000+', label: 'passionnés guidés' },
  { value: '97%', label: 'de satisfaction' },
  { value: '6', label: 'GUIDES TOURNAGES' },
  { value: '4.8★', label: 'note moyenne' }],

  featuresTitle: 'un film digne',
  featuresTitleAccent: 'des plus grands circuits',
  featuresDesc: 'Le guide DreamerLife Auto/Moto couvre chaque angle pour sublimer votre passion mécanique.',
  features: [
  { tag: 'Extérieur', title: 'Plans de carrosserie épiques', desc: "Capturez les courbes, les reflets et les détails de votre véhicule avec des angles dignes des plus grands magazines automobiles." },
  { tag: 'Action', title: 'Séquences de conduite dynamiques', desc: 'Le guide vous indique exactement comment filmer les accélérations, les virages et les dépassements pour un résultat spectaculaire.' },
  { tag: 'Intérieur', title: 'Ambiance cockpit', desc: 'Immortalisez le tableau de bord, les jauges et le regard du pilote pour une immersion totale.' }],

  stepsTitle: 'Filmez comme',
  stepsTitleAccent: 'un pro du circuit.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide Auto/Moto', desc: 'Sélectionnez le guide adapté à votre type de véhicule et à votre événement.', badge: 'Accès immédiat après paiement.' },
  { num: '02', title: 'Suivez les instructions sur votre smartphone', desc: 'Chaque scène est détaillée : angle, distance, vitesse idéale pour un rendu cinématographique.', badge: 'WebApp interactive' },
  { num: '03', title: 'Montez, partagez, impressionnez', desc: 'Recevez votre vidéo montée et partagez-la sur vos réseaux pour faire vibrer votre communauté.', badge: 'Compatible tous smartphones.' }],

  stepImage: "https://images.unsplash.com/photo-1686997878813-f69094295dac",
  stepImageAlt: 'Passionné filmant une voiture de sport avec son smartphone',
  testimonialTitle: 'DES PILOTES, DES PASSIONNÉS,',
  testimonialTitleAccent: 'DES MACHINES, DES FILMS',
  testimonials: [
  { name: 'Marc D.', role: 'Club Auto · Président', quote: 'Un outil indispensable pour notre club !', text: "Nous utilisons DreamerLife lors de tous nos rassemblements. Les membres repartent avec des vidéos professionnelles de leurs véhicules. L'engouement est total et les partages sur les réseaux explosent.", avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&q=85', avatarAlt: 'Marc D., président de club auto' },
  { name: 'Sophie L.', role: 'Motarde passionnée', quote: 'Ma moto n\'a jamais été aussi bien filmée !', text: "Le guide m'a appris des angles auxquels je n'aurais jamais pensé. Ma vidéo de road trip a fait le tour de ma communauté Instagram. Incroyable !", avatar: "https://images.unsplash.com/photo-1534063363244-7515362c98c0", avatarAlt: 'Sophie L., motarde' },
  { name: 'Pierre V.', role: 'Collectionneur · Bordeaux', quote: 'Mes voitures méritaient ce traitement !', text: "J'ai une collection de véhicules anciens et DreamerLife m'a permis de les filmer comme dans un documentaire de luxe. Le résultat est bluffant.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_11a2e4a58-1763295038790.png", avatarAlt: 'Pierre V., collectionneur' }],

  testimonialPhotos: [
  { src: "https://images.unsplash.com/photo-1667802560676-15689e54eed9", alt: 'Voiture de sport rouge' },
  { src: "https://images.unsplash.com/photo-1665349961794-ec861d3db376", alt: 'Moto sur route de montagne' },
  { src: "https://images.unsplash.com/photo-1642948818738-abe307b53bc6", alt: 'Voiture classique' },
  { src: "https://images.unsplash.com/photo-1681151373834-68cb52ea1b88", alt: 'Rassemblement automobile' }],

  videoTitle: 'Votre véhicule,',
  videoTitleAccent: 'votre film.',
  videoDesc: 'Des guides adaptés à chaque type de tournage automobile.',
  videoModes: [
  { tag: 'Vue extérieure', title: 'Tracking Shot', desc: 'Filmez votre véhicule en mouvement depuis l\'extérieur. Plans de suivi, contre-plongées et détails de carrosserie.', badge: 'Inclus dans tous les forfaits', image: "https://images.unsplash.com/photo-1731984955522-c5abea320a81", imageAlt: 'Tracking shot automobile' },
  { tag: 'Vue embarquée', title: 'Cockpit View', desc: 'Filmez depuis l\'intérieur du véhicule. Capturez l\'adrénaline, le tableau de bord et le regard du conducteur.', badge: 'Inclus dans Emotion & Prestige', image: "https://images.unsplash.com/photo-1719645818055-3da733c46535", imageAlt: 'Vue cockpit voiture' }],

  videoStyles: [
  { title: 'Racing', desc: 'Montage dynamique, musique électro, ralentis sur les accélérations. Pour l\'adrénaline pure.', image: "https://images.unsplash.com/photo-1700304721368-9cf55dfa6fcb", imageAlt: 'Style racing' },
  { title: 'Prestige', desc: 'Plans élégants, musique orchestrale, focus sur les détails. Pour sublimer votre collection.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1301702e3-1780419272441.png", imageAlt: 'Style prestige' },
  { title: 'Road Trip', desc: 'Ambiance voyage, paysages en arrière-plan, musique indie. Pour raconter votre aventure.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cc74c973-1780419272275.png", imageAlt: 'Style road trip' },
  { title: 'Vintage', desc: 'Grain cinéma, couleurs chaudes, musique jazz. Pour les véhicules d\'époque.', image: "https://images.unsplash.com/photo-1690545206333-8729b66af856", imageAlt: 'Style vintage' }],

  pricingTitle: 'Simple, Rapide,',
  pricingTitleAccent: 'Passionné.',
  pricingDesc: 'Choisissez le pack adapté à votre passion automobile.',
  plans: [
  {
    tag: 'Pour débuter',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Idéal pour filmer votre premier événement auto/moto avec style.',
    features: [
    { included: true, text: '1 guide interactif (Tracking Shot)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 4 heures' },
    { included: false, text: 'Guide Cockpit View' },
    { included: false, text: 'Personnalisation du générique' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Passionné',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'Accès complet pour capturer chaque angle de votre véhicule.',
    features: [
    { included: true, text: '2 guides interactifs (Tracking + Cockpit)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 2 heures' },
    { included: true, text: 'Insertion du nom du véhicule et de la date' }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'La vidéo ultime pour votre véhicule, digne des plus grandes productions.',
    features: [
    { included: true, text: '3 guides interactifs complets' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 15 minutes' },
    { included: true, text: 'Sans copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir pour filmer votre passion automobile.',
  faqs: [
  { q: 'Quel type de véhicule peut être filmé ?', a: 'Tous les véhicules : voitures de sport, motos, véhicules anciens, supercars, 4x4... Nos guides sont adaptés à chaque type de machine et à chaque contexte (circuit, route, rassemblement).' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit. Pour les plans embarqués, un support de fixation basique est recommandé mais non obligatoire.' },
  { q: 'Puis-je filmer lors d\'un rassemblement ou d\'un circuit ?', a: 'Absolument ! Nos guides sont spécialement conçus pour les événements automobiles, les journées circuit et les rassemblements de passionnés.' },
  { q: 'Comment recevoir ma vidéo montée ?', a: 'Après avoir soumis vos rushs via la WebApp, notre équipe monte votre vidéo selon le style choisi. Vous la recevez directement dans votre espace personnel.' }]

},
{
  id: 'monuments',
  label: 'Monuments',
  emoji: '🏛️',
  heroTitle: 'Chaque pierre,',
  heroTitleItalic: 'filmée',
  heroTitleEnd: 'raconte une histoire.',
  heroSubtitle: 'Guide cinématographique pour explorateurs du patrimoine',
  heroDesc: 'Transformez votre visite de monuments historiques en un documentaire personnel époustouflant.',
  heroBg: "https://img.rocket.new/generatedImages/rocket_gen_img_16ff64da8-1768718798696.png",
  stats: [
  { value: '25 000+', label: 'explorateurs guidés' },
  { value: '99%', label: 'de satisfaction' },
  { value: '8', label: 'GUIDES TOURNAGES' },
  { value: '4.9★', label: 'note moyenne' }],

  featuresTitle: 'un documentaire',
  featuresTitleAccent: 'digne des grands voyageurs',
  featuresDesc: 'Le guide DreamerLife Monuments révèle la majesté de chaque site avec des techniques cinématographiques.',
  features: [
  { tag: 'Architecture', title: 'Plans architecturaux majestueux', desc: "Capturez les façades, les détails sculptés et les perspectives qui révèlent toute la grandeur de l'architecture historique." },
  { tag: 'Atmosphère', title: 'Ambiance et lumière naturelle', desc: 'Le guide vous indique les meilleurs moments de la journée pour filmer chaque monument sous sa lumière la plus flatteuse.' },
  { tag: 'Récit', title: 'Narration visuelle', desc: 'Construisez un récit cohérent qui emmène le spectateur dans un voyage à travers le temps et l\'histoire.' }],

  stepsTitle: 'Explorez et filmez',
  stepsTitleAccent: 'comme un documentariste.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide Monument', desc: 'Sélectionnez le guide adapté au type de monument que vous visitez.', badge: 'Accès immédiat après paiement.' },
  { num: '02', title: 'Préparez votre visite avec la WebApp', desc: 'Découvrez les angles incontournables, les heures idéales et les détails à ne pas manquer.', badge: 'WebApp interactive' },
  { num: '03', title: 'Filmez, racontez, partagez', desc: 'Créez un documentaire personnel qui fera voyager vos proches à travers l\'histoire.', badge: 'Compatible tous smartphones.' }],

  stepImage: "https://images.unsplash.com/photo-1700900525568-190ab9ce0730",
  stepImageAlt: 'Touriste filmant la Tour Eiffel avec son smartphone',
  testimonialTitle: 'DES VOYAGEURS, DES EXPLORATEURS,',
  testimonialTitleAccent: 'DES MONUMENTS, DES FILMS',
  testimonials: [
  { name: 'Catherine B.', role: 'Guide touristique · Paris', quote: 'Un outil révolutionnaire pour mes clients !', text: "J'intègre DreamerLife dans mes visites guidées. Mes clients repartent avec un documentaire personnel de leur visite. L'expérience est enrichie et les avis sont excellents.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fad84229-1780419274465.png", avatarAlt: 'Catherine B., guide touristique' },
  { name: 'Antoine R.', role: 'Voyageur passionné', quote: 'Mes voyages ont une nouvelle dimension !', text: "Depuis que j'utilise DreamerLife, chaque monument que je visite devient un film. Ma chaîne YouTube a explosé grâce à la qualité des vidéos produites.", avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=85', avatarAlt: 'Antoine R., voyageur' },
  { name: 'Isabelle M.', role: 'Professeure d\'histoire', quote: 'Un support pédagogique exceptionnel !', text: "J'utilise DreamerLife avec mes élèves lors des sorties scolaires. Les vidéos créées deviennent de véritables supports pédagogiques. L'engagement des élèves est décuplé.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1fac48eb5-1763301771327.png", avatarAlt: 'Isabelle M., professeure' }],

  testimonialPhotos: [
  { src: "https://images.unsplash.com/photo-1529008525710-8d56ee351cdb", alt: 'Tour Eiffel de nuit' },
  { src: "https://images.unsplash.com/photo-1690705931824-c49ffc6af4d9", alt: 'Taj Mahal' },
  { src: "https://images.unsplash.com/photo-1611733980792-4e2bec9cc475", alt: 'Colisée de Rome' },
  { src: "https://images.unsplash.com/photo-1620815253545-03cf0bd96140", alt: 'Château médiéval' }],

  videoTitle: 'Votre voyage,',
  videoTitleAccent: 'votre documentaire.',
  videoDesc: 'Des guides adaptés à chaque type de monument et de patrimoine.',
  videoModes: [
  { tag: 'Vue extérieure', title: 'Architecture', desc: 'Capturez les façades, les détails et les perspectives qui révèlent toute la grandeur du monument.', badge: 'Inclus dans tous les forfaits', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c51f265d-1780419271114.png", imageAlt: 'Architecture monument' },
  { tag: 'Vue immersive', title: 'Intérieur & Détails', desc: 'Explorez l\'intérieur, les fresques, les sculptures et les détails qui racontent l\'histoire du lieu.', badge: 'Inclus dans Emotion & Prestige', image: "https://images.unsplash.com/photo-1677517661360-1def7f976594", imageAlt: 'Intérieur monument' }],

  videoStyles: [
  { title: 'Documentaire', desc: 'Style reportage, narration visuelle, musique orchestrale. Pour un voyage dans le temps.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_112fa81ad-1770400248616.png", imageAlt: 'Style documentaire' },
  { title: 'Cinéma', desc: 'Plans larges, ralentis majestueux, musique épique. Pour une émotion grand écran.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1af5e04d4-1778826029062.png", imageAlt: 'Style cinéma' },
  { title: 'Voyage', desc: 'Ambiance exploration, transitions fluides, musique world. Pour raconter votre aventure.', image: "https://images.unsplash.com/photo-1710439920680-183f97b26fd2", imageAlt: 'Style voyage' },
  { title: 'Poétique', desc: 'Plans contemplatifs, musique douce, focus sur les détails. Pour une vision artistique.', image: "https://images.unsplash.com/photo-1663657207527-a97e770ef6d7", imageAlt: 'Style poétique' }],

  pricingTitle: 'Explorez, Filmez,',
  pricingTitleAccent: 'Immortalisez.',
  pricingDesc: 'Choisissez le pack adapté à votre exploration patrimoniale.',
  plans: [
  {
    tag: 'Pour commencer',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Idéal pour filmer votre première visite de monument avec style.',
    features: [
    { included: true, text: '1 guide interactif (Architecture)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 4 heures' },
    { included: false, text: 'Guide Intérieur & Détails' },
    { included: false, text: 'Personnalisation du générique' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Explorateur',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'Accès complet pour documenter chaque aspect du monument.',
    features: [
    { included: true, text: '2 guides interactifs (Architecture + Intérieur)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 2 heures' },
    { included: true, text: 'Insertion du nom du monument et de la date' }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'Le documentaire ultime de votre visite patrimoniale.',
    features: [
    { included: true, text: '3 guides interactifs complets' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 15 minutes' },
    { included: true, text: 'Sans copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir pour filmer votre patrimoine.',
  faqs: [
  { q: 'Quels types de monuments sont couverts ?', a: 'Tous les monuments historiques : châteaux, cathédrales, musées, sites archéologiques, palais, tours... Nos guides sont adaptés à chaque type de patrimoine architectural.' },
  { q: 'Puis-je filmer à l\'intérieur des monuments ?', a: 'Nos guides respectent les règles de chaque site. Nous vous indiquons les zones autorisées et les meilleures alternatives pour les zones restreintes.' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit. Pour les plans en hauteur, un mini-trépied peut être utile mais reste optionnel.' },
  { q: 'Comment recevoir ma vidéo montée ?', a: 'Après avoir soumis vos rushs via la WebApp, notre équipe monte votre documentaire selon le style choisi. Vous le recevez directement dans votre espace personnel.' }]

},
{
  id: 'immobilier',
  label: 'Immobilier',
  emoji: '🏠',
  heroTitle: 'Chaque bien,',
  heroTitleItalic: 'filmé',
  heroTitleEnd: 'se vend plus vite.',
  heroSubtitle: 'Guide vidéo professionnel pour agents et propriétaires',
  heroDesc: 'Créez des visites virtuelles et des vidéos de présentation qui font la différence sur le marché immobilier.',
  heroBg: "https://images.unsplash.com/photo-1645524612151-d0e383e807e9",
  stats: [
  { value: '5 000+', label: 'biens filmés' },
  { value: '3x', label: 'plus de contacts' },
  { value: '10', label: 'GUIDES TOURNAGES' },
  { value: '4.9★', label: 'note moyenne' }],

  featuresTitle: 'une présentation',
  featuresTitleAccent: 'qui fait vendre',
  featuresDesc: 'Le guide DreamerLife Immobilier couvre chaque pièce et chaque atout de votre bien.',
  features: [
  { tag: 'Extérieur', title: 'Façade et environnement', desc: "Capturez la façade, le jardin, la piscine et l'environnement avec des angles qui mettent en valeur le cadre de vie." },
  { tag: 'Intérieur', title: 'Visite virtuelle guidée', desc: 'Le guide vous indique comment filmer chaque pièce pour créer une visite fluide et immersive qui donne envie.' },
  { tag: 'Atouts', title: 'Points forts mis en scène', desc: 'Cheminée, vue panoramique, cuisine équipée... Chaque atout est filmé pour maximiser son impact.' }],

  stepsTitle: 'Filmez votre bien,',
  stepsTitleAccent: 'vendez plus vite.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide Immobilier', desc: 'Sélectionnez le guide adapté au type de bien : appartement, maison, villa, local commercial.', badge: 'Accès immédiat après paiement.' },
  { num: '02', title: 'Suivez le plan de tournage', desc: 'Chaque pièce, chaque angle, chaque détail est planifié pour créer une visite virtuelle professionnelle.', badge: 'WebApp interactive' },
  { num: '03', title: 'Publiez et attirez les acheteurs', desc: 'Votre vidéo professionnelle se démarque sur toutes les plateformes immobilières.', badge: 'Compatible tous smartphones.' }],

  stepImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1b53ef675-1767292059078.png",
  stepImageAlt: 'Agent immobilier filmant un appartement avec son smartphone',
  testimonialTitle: 'DES AGENTS, DES PROPRIÉTAIRES,',
  testimonialTitleAccent: 'DES BIENS, DES VENTES',
  testimonials: [
  { name: 'Laurent P.', role: 'Agent immobilier · Lyon', quote: 'Mes annonces ont 3x plus de vues !', text: "Depuis que j'utilise DreamerLife pour mes visites vidéo, mes annonces génèrent trois fois plus de contacts. Les acheteurs arrivent déjà conquis. Un investissement qui se rentabilise immédiatement.", avatar: "https://images.unsplash.com/photo-1637809612985-5b6a6dd54d2e", avatarAlt: 'Laurent P., agent immobilier' },
  { name: 'Marie-Claire D.', role: 'Propriétaire · Bordeaux', quote: 'Vendu en 2 semaines grâce à la vidéo !', text: "Mon appartement était sur le marché depuis 3 mois sans résultat. Après avoir créé une vidéo avec DreamerLife, j'ai reçu 8 visites en une semaine et vendu au prix demandé.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_19170c7b8-1772742079116.png", avatarAlt: 'Marie-Claire D., propriétaire' },
  { name: 'Thomas B.', role: 'Promoteur immobilier', quote: 'Un outil essentiel pour nos programmes !', text: "DreamerLife nous permet de présenter nos programmes neufs de façon cinématographique. Les réservations sur plan ont augmenté de 40% depuis que nous utilisons ces vidéos.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_1caf8de17-1763296257090.png", avatarAlt: 'Thomas B., promoteur' }],

  testimonialPhotos: [
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1770ba26e-1772165936231.png", alt: 'Belle villa moderne' },
  { src: "https://images.unsplash.com/photo-1679001604244-222374171273", alt: 'Maison avec piscine' },
  { src: "https://images.unsplash.com/photo-1585530524789-9eea58c59596", alt: 'Appartement moderne' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1c414b945-1772365136549.png", alt: 'Cuisine équipée' }],

  videoTitle: 'Votre bien,',
  videoTitleAccent: 'votre vitrine.',
  videoDesc: 'Des guides adaptés à chaque type de bien immobilier.',
  videoModes: [
  { tag: 'Vue extérieure', title: 'Façade & Environnement', desc: 'Capturez l\'extérieur du bien, le quartier et l\'environnement pour une première impression parfaite.', badge: 'Inclus dans tous les forfaits', image: "https://img.rocket.new/generatedImages/rocket_gen_img_117a9ac2c-1780419273368.png", imageAlt: 'Façade immobilier' },
  { tag: 'Visite intérieure', title: 'Visite Virtuelle', desc: 'Filmez chaque pièce avec fluidité pour créer une visite virtuelle immersive qui donne envie d\'acheter.', badge: 'Inclus dans Emotion & Prestige', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c41fb4af-1765990978273.png", imageAlt: 'Visite intérieure' }],

  videoStyles: [
  { title: 'Luxe', desc: 'Plans élégants, musique sophistiquée, transitions douces. Pour les biens haut de gamme.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_190f80b44-1780419271325.png", imageAlt: 'Style luxe' },
  { title: 'Moderne', desc: 'Montage dynamique, musique contemporaine, focus sur les matériaux. Pour les biens neufs.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a19c7feb-1780419272425.png", imageAlt: 'Style moderne' },
  { title: 'Familial', desc: 'Ambiance chaleureuse, musique douce, focus sur les espaces de vie. Pour les maisons familiales.', image: "https://images.unsplash.com/photo-1661524410683-f08f445d32aa", imageAlt: 'Style familial' },
  { title: 'Investissement', desc: 'Style professionnel, mise en avant des atouts locatifs, musique corporate. Pour les investisseurs.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1bcabecd3-1780419270765.png", imageAlt: 'Style investissement' }],

  pricingTitle: 'Filmez, Vendez,',
  pricingTitleAccent: 'Réussissez.',
  pricingDesc: 'Choisissez le pack adapté à votre bien immobilier.',
  plans: [
  {
    tag: 'Pour débuter',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Idéal pour créer votre première vidéo immobilière professionnelle.',
    features: [
    { included: true, text: '1 guide interactif (Façade & Extérieur)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 4 heures' },
    { included: false, text: 'Guide Visite Virtuelle' },
    { included: false, text: 'Personnalisation avec adresse du bien' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Pro',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'La solution complète pour présenter votre bien sous son meilleur jour.',
    features: [
    { included: true, text: '2 guides interactifs (Extérieur + Visite)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 2 heures' },
    { included: true, text: 'Insertion de l\'adresse et des caractéristiques' }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'La vidéo immobilière ultime pour les biens d\'exception.',
    features: [
    { included: true, text: '3 guides interactifs complets' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 15 minutes' },
    { included: true, text: 'Sans copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir pour valoriser votre bien immobilier.',
  faqs: [
  { q: 'Quel type de bien peut être filmé ?', a: 'Tous les types de biens : appartements, maisons, villas, locaux commerciaux, bureaux, terrains... Nos guides sont adaptés à chaque configuration.' },
  { q: 'La vidéo est-elle compatible avec les plateformes immobilières ?', a: 'Oui, les vidéos produites sont optimisées pour toutes les plateformes : SeLoger, LeBonCoin, Bien\'ici, Logic-Immo, et les réseaux sociaux.' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit. Pour les plans en hauteur ou les grands espaces, un mini-trépied peut améliorer le résultat.' },
  { q: 'Combien de temps prend le tournage ?', a: 'En moyenne 30 à 45 minutes pour un bien standard. Notre guide optimise votre temps pour couvrir tous les points essentiels sans vous faire perdre de temps.' }]

},
{
  id: 'vignobles',
  label: 'Vignobles',
  emoji: '🍷',
  heroTitle: 'Chaque terroir,',
  heroTitleItalic: 'filmé',
  heroTitleEnd: 'devient un grand cru.',
  heroSubtitle: 'Guide cinématographique pour domaines viticoles',
  heroDesc: 'Sublimez votre domaine, vos vendanges et votre savoir-faire avec des vidéos dignes des plus grands vignobles.',
  heroBg: "https://images.unsplash.com/photo-1642522044754-bd69677a4d69",
  stats: [
  { value: '2 000+', label: 'domaines filmés' },
  { value: '96%', label: 'de satisfaction' },
  { value: '7', label: 'GUIDES TOURNAGES' },
  { value: '4.8★', label: 'note moyenne' }],

  featuresTitle: 'un film qui',
  featuresTitleAccent: 'fait voyager le palais',
  featuresDesc: 'Le guide DreamerLife Vignobles capture l\'essence de votre terroir et de votre passion.',
  features: [
  { tag: 'Terroir', title: 'Paysages de vignes épiques', desc: "Capturez les rangées de vignes, les couchers de soleil sur le domaine et les paysages qui font l'identité de votre terroir." },
  { tag: 'Savoir-faire', title: 'Gestes et traditions', desc: 'Le guide vous indique comment filmer les vendanges, la vinification et les gestes ancestraux qui font votre réputation.' },
  { tag: 'Dégustation', title: 'L\'art de la dégustation', desc: 'Immortalisez les moments de dégustation, les reflets du vin et les émotions des visiteurs pour une communication authentique.' }],

  stepsTitle: 'Filmez votre passion,',
  stepsTitleAccent: 'partagez votre terroir.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide Vignoble', desc: 'Sélectionnez le guide adapté à votre activité : domaine, vendanges, œnotourisme.', badge: 'Accès immédiat après paiement.' },
  { num: '02', title: 'Planifiez votre tournage avec la WebApp', desc: 'Découvrez les meilleures saisons, heures et angles pour sublimer votre domaine.', badge: 'WebApp interactive' },
  { num: '03', title: 'Filmez, montez, communiquez', desc: 'Votre vidéo devient votre meilleur outil de communication pour attirer visiteurs et acheteurs.', badge: 'Compatible tous smartphones.' }],

  stepImage: "https://images.unsplash.com/photo-1646492235768-5a0324b6fe15",
  stepImageAlt: 'Vigneron filmant ses vignes au coucher du soleil',
  testimonialTitle: 'DES VIGNERONS, DES DOMAINES,',
  testimonialTitleAccent: 'DES TERROIRS, DES FILMS',
  testimonials: [
  { name: 'Jean-Pierre M.', role: 'Domaine Château Lumière · Propriétaire', quote: 'Notre domaine n\'a jamais été aussi bien représenté !', text: "DreamerLife a transformé notre communication. Nos vidéos de vendanges et de dégustation attirent des visiteurs du monde entier. Les réservations d'œnotourisme ont doublé en un an.", avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=120&q=85', avatarAlt: 'Jean-Pierre M., vigneron' },
  { name: 'Élise V.', role: 'Responsable œnotourisme · Bordeaux', quote: 'Un outil parfait pour nos visiteurs !', text: "Nous proposons DreamerLife à nos visiteurs lors des journées portes ouvertes. Ils repartent avec un film souvenir de leur visite et deviennent nos meilleurs ambassadeurs sur les réseaux.", avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=85', avatarAlt: 'Élise V., responsable œnotourisme' },
  { name: 'Robert C.', role: 'Caviste · Paris', quote: 'Mes fournisseurs ont une nouvelle image !', text: "J'ai recommandé DreamerLife à plusieurs domaines que je référence. Les vidéos produites ont transformé leur image et mes clients sont conquis par ces présentations cinématographiques.", avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=120&q=85', avatarAlt: 'Robert C., caviste' }],

  testimonialPhotos: [
  { src: "https://images.unsplash.com/photo-1532794291898-b303a0b62753", alt: 'Vignes au coucher du soleil' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1d039e8b1-1776223607433.png", alt: 'Vendanges en cours' },
  { src: "https://images.unsplash.com/photo-1698827016432-465cf8dd5dd8", alt: 'Dégustation de vin' },
  { src: "https://images.unsplash.com/photo-1728873005767-2c609eb5ca68", alt: 'Cave à vin' }],

  videoTitle: 'Votre terroir,',
  videoTitleAccent: 'votre signature.',
  videoDesc: 'Des guides adaptés à chaque moment de la vie d\'un domaine viticole.',
  videoModes: [
  { tag: 'Vue extérieure', title: 'Paysage & Terroir', desc: 'Capturez les vignes, le domaine et les paysages qui font l\'identité unique de votre terroir.', badge: 'Inclus dans tous les forfaits', image: "https://img.rocket.new/generatedImages/rocket_gen_img_11adba593-1780419272838.png", imageAlt: 'Paysage vignoble' },
  { tag: 'Vue immersive', title: 'Savoir-faire & Dégustation', desc: 'Filmez les gestes de vinification, les caves et les moments de dégustation pour une immersion totale.', badge: 'Inclus dans Emotion & Prestige', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1027812b9-1780419273973.png", imageAlt: 'Dégustation vignoble' }],

  videoStyles: [
  { title: 'Prestige', desc: 'Plans élégants, musique classique, focus sur les détails. Pour les grands crus.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_10035c7a1-1780419272106.png", imageAlt: 'Style prestige vignoble' },
  { title: 'Terroir', desc: 'Ambiance authentique, musique folk, plans larges. Pour raconter l\'histoire du domaine.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_13c3a9ab9-1780419273676.png", imageAlt: 'Style terroir' },
  { title: 'Saisons', desc: 'Montage chronologique, transitions saisonnières. Pour montrer la vie du vignoble.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1975c9be8-1780419272408.png", imageAlt: 'Style saisons' },
  { title: 'Œnotourisme', desc: 'Style accueillant, musique douce, focus sur l\'expérience visiteur. Pour attirer les touristes.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_127633859-1769194284493.png", imageAlt: 'Style œnotourisme' }],

  pricingTitle: 'Sublimez, Partagez,',
  pricingTitleAccent: 'Séduisez.',
  pricingDesc: 'Choisissez le pack adapté à votre domaine viticole.',
  plans: [
  {
    tag: 'Pour commencer',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Idéal pour créer votre première vidéo de domaine viticole.',
    features: [
    { included: true, text: '1 guide interactif (Paysage & Terroir)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 4 heures' },
    { included: false, text: 'Guide Savoir-faire & Dégustation' },
    { included: false, text: 'Personnalisation avec nom du domaine' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Vigneron',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'La solution complète pour présenter votre domaine et votre savoir-faire.',
    features: [
    { included: true, text: '2 guides interactifs (Terroir + Savoir-faire)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 2 heures' },
    { included: true, text: 'Insertion du nom du domaine et du millésime' }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'Le film ultime pour votre domaine, digne des plus grands vignobles.',
    features: [
    { included: true, text: '3 guides interactifs complets' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 15 minutes' },
    { included: true, text: 'Sans copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir pour sublimer votre domaine viticole.',
  faqs: [
  { q: 'Quelle est la meilleure saison pour filmer un vignoble ?', a: 'Chaque saison offre des opportunités uniques : le printemps pour les bourgeons, l\'été pour les vignes vertes, l\'automne pour les vendanges et les couleurs dorées, l\'hiver pour l\'architecture du vignoble.' },
  { q: 'Puis-je filmer pendant les vendanges ?', a: 'Absolument ! Les vendanges sont l\'un des moments les plus cinématographiques de la vie d\'un domaine. Notre guide spécial vendanges vous accompagne pas à pas.' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit. Pour les plans de paysage, un mini-trépied peut améliorer la stabilité.' },
  { q: 'La vidéo peut-elle être utilisée pour l\'export ?', a: 'Oui, les vidéos sont produites en haute qualité et peuvent être utilisées pour toutes vos communications : site web, réseaux sociaux, salons professionnels, export international.' }]

},
{
  id: 'evenementiels',
  label: 'Évènementiels',
  emoji: '🎉',
  heroTitle: 'Chaque événement,',
  heroTitleItalic: 'filmé',
  heroTitleEnd: 'reste gravé à jamais.',
  heroSubtitle: 'Guide vidéo professionnel pour organisateurs et participants',
  heroDesc: 'Capturez l\'énergie, les émotions et les moments forts de vos événements avec un guide cinématographique.',
  heroBg: "https://images.unsplash.com/photo-1642522044754-bd69677a4d69",
  stats: [
  { value: '10 000+', label: 'événements filmés' },
  { value: '98%', label: 'de satisfaction' },
  { value: '9', label: 'GUIDES TOURNAGES' },
  { value: '4.9★', label: 'note moyenne' }],

  featuresTitle: 'un film qui',
  featuresTitleAccent: 'capture l\'instant',
  featuresDesc: 'Le guide DreamerLife Évènementiels couvre chaque moment fort de votre événement.',
  features: [
  { tag: 'Ambiance', title: 'L\'énergie de la salle', desc: "Capturez l'atmosphère, la foule, les lumières et l'énergie collective qui font l'âme de votre événement." },
  { tag: 'Moments clés', title: 'Instants décisifs', desc: 'Le guide vous indique exactement quand et comment filmer les discours, les remises de prix, les surprises et les moments d\'émotion.' },
  { tag: 'Coulisses', title: 'Behind the scenes', desc: 'Immortalisez les préparatifs, les coulisses et les moments informels qui donnent de l\'authenticité à votre film.' }],

  stepsTitle: 'Filmez l\'instant,',
  stepsTitleAccent: 'immortalisez l\'émotion.',
  steps: [
  { num: '01', title: 'Choisissez votre Guide Événementiel', desc: 'Sélectionnez le guide adapté à votre type d\'événement : conférence, gala, concert, mariage, séminaire.', badge: 'Accès immédiat après paiement.' },
  { num: '02', title: 'Préparez votre plan de tournage', desc: 'Anticipez les moments clés et positionnez-vous aux meilleurs endroits pour ne rien manquer.', badge: 'WebApp interactive' },
  { num: '03', title: 'Filmez, montez, revivez', desc: 'Votre film d\'événement devient un souvenir collectif que tous les participants voudront partager.', badge: 'Compatible tous smartphones.' }],

  stepImage: "https://images.unsplash.com/photo-1708860027560-c6e581be97b7",
  stepImageAlt: 'Participant filmant un événement avec son smartphone',
  testimonialTitle: 'DES ORGANISATEURS, DES PARTICIPANTS,',
  testimonialTitleAccent: 'DES ÉVÉNEMENTS, DES FILMS',
  testimonials: [
  { name: 'Amélie F.', role: 'Event Manager · Paris', quote: 'Mes clients adorent repartir avec leur film !', text: "DreamerLife est devenu un service premium que j'intègre dans tous mes événements. Les participants repartent avec un film professionnel de la soirée. L'effet wow est garanti et les recommandations explosent.", avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=120&q=85', avatarAlt: 'Amélie F., event manager' },
  { name: 'Nicolas T.', role: 'Directeur Communication · Lyon', quote: 'Notre séminaire annuel immortalisé !', text: "Grâce à DreamerLife, notre séminaire annuel a été filmé par les participants eux-mêmes. Le film final est d'une qualité professionnelle et reflète parfaitement l'esprit de notre équipe.", avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=120&q=85', avatarAlt: 'Nicolas T., directeur communication' },
  { name: 'Sandrine B.', role: 'Mariée · Provence', quote: 'Notre mariage revit à chaque visionnage !', text: "Nous avons utilisé DreamerLife pour notre mariage. Chaque invité a filmé selon le guide et le montage final est un chef-d'œuvre. Nous le regardons encore et encore avec les mêmes émotions.", avatar: "https://img.rocket.new/generatedImages/rocket_gen_img_144765580-1780419274971.png", avatarAlt: 'Sandrine B., mariée' }],

  testimonialPhotos: [
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1a4ad6cc8-1772792192344.png", alt: 'Salle de concert lumineuse' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_1bab692f7-1768167527125.png", alt: 'Conférence professionnelle' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_15a69c55c-1765287133840.png", alt: 'Mariage élégant' },
  { src: "https://img.rocket.new/generatedImages/rocket_gen_img_122bb2ff2-1766977906215.png", alt: 'Gala de soirée' }],

  videoTitle: 'Votre événement,',
  videoTitleAccent: 'votre légende.',
  videoDesc: 'Des guides adaptés à chaque type d\'événement.',
  videoModes: [
  { tag: 'Vue d\'ensemble', title: 'Ambiance Générale', desc: 'Capturez l\'atmosphère globale, la salle, la foule et l\'énergie collective de votre événement.', badge: 'Inclus dans tous les forfaits', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1cee44501-1773179121471.png", imageAlt: 'Ambiance événement' },
  { tag: 'Vue rapprochée', title: 'Moments & Émotions', desc: 'Filmez les visages, les réactions et les moments d\'émotion qui font la magie de votre événement.', badge: 'Inclus dans Emotion & Prestige', image: "https://img.rocket.new/generatedImages/rocket_gen_img_195bce709-1780419273372.png", imageAlt: 'Émotions événement' }],

  videoStyles: [
  { title: 'Dynamique', desc: 'Montage énergique, musique électro, transitions rapides. Pour les événements festifs.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_1b988d9fe-1765338412379.png", imageAlt: 'Style dynamique' },
  { title: 'Corporate', desc: 'Style professionnel, musique corporate, focus sur les moments clés. Pour les événements d\'entreprise.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_15bb19fce-1780419271175.png", imageAlt: 'Style corporate' },
  { title: 'Émotion', desc: 'Musique douce, ralentis sur les regards, focus sur les émotions. Pour les événements intimes.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_10c0ca7cb-1780419272293.png", imageAlt: 'Style émotion' },
  { title: 'Prestige', desc: 'Plans élégants, musique orchestrale, transitions douces. Pour les galas et cérémonies.', image: "https://img.rocket.new/generatedImages/rocket_gen_img_13291b665-1780419272398.png", imageAlt: 'Style prestige' }],

  pricingTitle: 'Capturez, Partagez,',
  pricingTitleAccent: 'Impressionnez.',
  pricingDesc: 'Choisissez le pack adapté à votre événement.',
  plans: [
  {
    tag: 'Pour débuter',
    name: 'Découverte',
    price: '€19.90',
    period: '/TTC/vidéo',
    desc: 'Idéal pour filmer votre premier événement avec style.',
    features: [
    { included: true, text: '1 guide interactif (Ambiance Générale)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 4 heures' },
    { included: false, text: 'Guide Moments & Émotions' },
    { included: false, text: 'Personnalisation avec nom de l\'événement' }],

    cta: 'Commencer'
  },
  {
    tag: 'Le choix Organisateur',
    name: 'Emotion',
    price: '€29.90',
    period: '/TTC/vidéo',
    desc: 'La solution complète pour immortaliser chaque moment de votre événement.',
    features: [
    { included: true, text: '2 guides interactifs (Ambiance + Émotions)' },
    { included: true, text: "Jusqu'à 6 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 2 heures' },
    { included: true, text: "Insertion du nom de l'événement et de la date" }],

    cta: 'Choisir Emotion',
    popular: true
  },
  {
    tag: "L'expérience ultime",
    name: 'Prestige',
    price: '€49.90',
    period: '/TTC/vidéo',
    desc: 'Le film ultime pour votre événement, digne des plus grandes productions.',
    features: [
    { included: true, text: '3 guides interactifs complets' },
    { included: true, text: "Jusqu'à 8 scènes guidées" },
    { included: true, text: 'Conseils cadrage smartphone' },
    { included: true, text: 'Accès illimité WebApp mobile' },
    { included: true, text: 'Réception vidéo sous 15 minutes' },
    { included: true, text: 'Sans copyright DreamerLife' }],

    cta: 'Choisir Prestige'
  }],

  faqTitle: 'Vos questions,',
  faqTitleAccent: 'nos réponses.',
  faqDesc: 'Tout ce que vous devez savoir pour filmer votre événement.',
  faqs: [
  { q: 'Quels types d\'événements peuvent être filmés ?', a: 'Tous les événements : mariages, galas, conférences, séminaires, concerts, festivals, remises de prix, soirées d\'entreprise... Nos guides sont adaptés à chaque contexte.' },
  { q: 'Combien de personnes peuvent filmer simultanément ?', a: 'Plusieurs participants peuvent utiliser le guide simultanément. Chacun filme selon ses instructions et les rushs sont ensuite combinés pour créer un film collectif riche.' },
  { q: "Ai-je besoin d'un équipement spécial ?", a: 'Non, un smartphone récent suffit. Pour les événements en soirée, nous recommandons d\'activer le mode nuit de votre appareil.' },
  { q: 'Peut-on filmer un événement privé comme un mariage ?', a: 'Absolument ! DreamerLife est parfait pour les mariages, anniversaires et célébrations privées. Vos invités deviennent vos caméramans et le résultat est un film collectif unique.' }]

}];


export const pricingToggles: PricingToggle[] = [
{ label: 'Par vidéo' },
{ label: 'OFFRE DE LANCEMENT', discount: '-20%' }];